class RelativeTimeElement {
  constructor(element) {
    var time = jQuery(element).data("datetime");

    // Server emits datetimes as `YYYY-MM-DD HH:mm:ss ZZ` (e.g.
    // `2026-03-10 09:12:36 -0700`) which moment can't auto-parse — give it
    // an explicit format string to silence the deprecation warning and
    // fall-back to `new Date()`.
    jQuery(element).text(moment(time, "YYYY-MM-DD HH:mm:ss ZZ").fromNow());
  }
}

jQuery(function () {
  jQuery('[data-date-format="relative"]').each(function () {
    new RelativeTimeElement(this);
  });
});

window.RelativeTimeElement = RelativeTimeElement;
